import React from 'react'
import { FcmSendIntegrationApiVersion, IAbstractNativeFcmSendIntegration } from '../../interfaces/send-integrations'
import {
    NativeLegacyFcmConfiguration,
    NativeV1FcmConfiguration,
} from '../../models/send-integration-configurations/native-fcm-configurations.model'
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Flex, Form, Space, Typography, notification, theme, ConfigProvider } from 'antd'
import CopyToClipboard from 'react-copy-to-clipboard'
import { getClassNames } from '../../_utils/classnames'
import { simpleNotification } from '../../_utils/utils'
import { SETTINGS_WELL_FORM_LAYOUT } from '../../theme/constants'

type NativeFcmIntegrationWellProps = {
    fcmConfig: IAbstractNativeFcmSendIntegration
}

export const NativeFcmIntegrationWell = (props: NativeFcmIntegrationWellProps) => {
    let configClass: typeof NativeV1FcmConfiguration | typeof NativeLegacyFcmConfiguration | undefined
    switch (props.fcmConfig.apiVersion) {
        case FcmSendIntegrationApiVersion.V1:
            configClass = NativeV1FcmConfiguration
            break

        case FcmSendIntegrationApiVersion.LEGACY:
            configClass = NativeLegacyFcmConfiguration
            break
    }

    const config = configClass?.build(props.fcmConfig)
    const enabled = config?.getIsActive() ?? false
    const handleCopied = React.useCallback((field: string) => {
        notification.destroy()
        simpleNotification('success', `Your ${field} has been copied!`)
    }, [])

    const { token } = theme.useToken()
    return (
        <Flex vertical gap={8}>
            <Form {...SETTINGS_WELL_FORM_LAYOUT} colon={false} requiredMark={false} labelAlign="left" size="small">
                <Space size={6} className="integrations-section-title">
                    <span className={enabled ? 'enabled' : 'disabled'}>
                        {enabled ? (
                            <CheckCircleOutlined style={{ color: token.colorSuccess }} />
                        ) : (
                            <CloseCircleOutlined style={{ color: token.colorError }} />
                        )}
                    </span>
                    <Typography.Text>NATIVE</Typography.Text>
                </Space>

                {!enabled ? (
                    <Form.Item label="Status">
                        <Typography.Text type="secondary">Not Enabled</Typography.Text>
                    </Form.Item>
                ) : (
                    <>
                        <Form.Item label="Sender ID">
                            <span className={getClassNames('can-copy')}>
                                <CopyToClipboard
                                    onCopy={() => handleCopied('sender id')}
                                    text={config?.getSenderId() ?? ''}
                                >
                                    <Typography.Text>{config?.getSenderId()}</Typography.Text>
                                </CopyToClipboard>
                            </span>
                        </Form.Item>

                        {config instanceof NativeV1FcmConfiguration && (
                            <Form.Item label="Service Account JSON File URL">
                                <span className={getClassNames('can-copy')}>
                                    <CopyToClipboard
                                        onCopy={() => handleCopied('service account json file url')}
                                        text={config.getServiceAccountJsonFileUrl() ?? ''}
                                    >
                                        <Typography.Text>{config.getServiceAccountJsonFileUrl()}</Typography.Text>
                                    </CopyToClipboard>
                                </span>
                            </Form.Item>
                        )}
                    </>
                )}
            </Form>
        </Flex>
    )
}
